export default __webpack_public_path__ + "static/media/ic_blue_tick.deac60df.svg";